module.exports = __webpack_public_path__ + "7e4b29ba/img/pdf-icon.79f04a36.svg";